// material-ui
import { Alert, Button, Fade, Grow, IconButton, Slide, Snackbar as MuiSnackbar } from '@mui/material';

import { useDispatch, useSelector } from 'store';
import { closeSnackbar } from 'store/slices/snackbar';

// assets
import CloseIcon from '@mui/icons-material/Close';

// animation function
function TransitionSlideLeft(props) {
    return <Slide {...props} direction="left" />;
}

function TransitionSlideUp(props) {
    return <Slide {...props} direction="up" />;
}

function TransitionSlideRight(props) {
    return <Slide {...props} direction="right" />;
}

function TransitionSlideDown(props) {
    return <Slide {...props} direction="down" />;
}

function GrowTransition(props) {
    return <Grow {...props} />;
}

// animation options
const animation = {
    SlideLeft: TransitionSlideLeft,
    SlideUp: TransitionSlideUp,
    SlideRight: TransitionSlideRight,
    SlideDown: TransitionSlideDown,
    Grow: GrowTransition,
    Fade
};

// ==============================|| SNACKBAR ||============================== //

const Snackbar = () => {
    const dispatch = useDispatch();
    const { actionButton, anchorOrigin, alert, close, message, open, transition, variant } = useSelector((state) => state.snackbar);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        dispatch(closeSnackbar());
    };

    return variant === 'alert' ? (
        <MuiSnackbar
            TransitionComponent={animation[transition || 'Fade']}
            anchorOrigin={anchorOrigin}
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
        >
            <Alert
                variant={alert.variant}
                color={alert.color}
                action={
                    <>
                        {actionButton && (
                            <Button size="small" onClick={handleClose} sx={{ color: 'background.paper' }}>
                                UNDO
                            </Button>
                        )}
                        {close && (
                            <IconButton sx={{ color: 'background.paper' }} size="small" aria-label="close" onClick={handleClose}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        )}
                    </>
                }
                sx={{ ...(alert.variant === 'outlined' && { bgcolor: 'background.paper' }) }}
            >
                {message || ''}
            </Alert>
        </MuiSnackbar>
    ) : (
        <MuiSnackbar
            anchorOrigin={anchorOrigin}
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            message={message || ''}
            TransitionComponent={animation[transition || 'Fade']}
            action={
                <>
                    <Button color="secondary" size="small" onClick={handleClose}>
                        UNDO
                    </Button>
                    <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose} sx={{ mt: 0.25 }}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </>
            }
        />
    );
};

export default Snackbar;
